<template>
<div>
  <generic-view
    title="Mobile Phones"
    entity_name="mobilePhone"
    :headers="headers"
    :user_id="user_id"
    :driver_id="driver_id"
    icon="mdi-phone"
  >
  </generic-view>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props:['user_id','driver_id'], //the phone might belong to a user or a driver
  computed:{
    headers(){
      return [
                {
                    text:"Phone Number",
                    value:"phoneNumber",
                    type:'textfield'
                },
                {
                    text:"IMEI",
                    value:"imei",
                    type:'textfield'
                },
                {
                    text:'MSISDN',
                    value:'msisdn',
                    type:'textfield'
                },
                {
                    text:'Driver',
                    value:'driverId',
                    type:'autocomplete'
                },
                {
                    text:'User',
                    value:'userId',
                    type:'autocomplete'
                }
            ]
      }
  }
}
</script>